<template lang="pug">
    form-group-layout.input-field.input-box-field(:label='label' v-bind='$attrs' :class='theClass')
        template(v-slot='{invalid, errors, touch, delayedTouch}')
            div.input-box-field__label-and-field
                label(v-if='!hideLabel && label') {{ label }}
                div.input-box-field__container
                    div.input-box-field__container-field
                        div.input-box-field__wrap(@mouseover='fieldHover = true' @mouseleave='fieldHover = false')
                            input.form-control(type='text' v-model='modelNoUnit' :class='fieldClass'
                                    :invalid='invalid' :placeholder='placeholder' :disabled='disabled' :readonly='readonly'
                                    @input='delayedTouch' @change='change' @focus='onFocus' @blur='touch(); onBlur();'
                                    @keypress='checkType' ref='field')

                            div.input-box-field__unit(v-if='selectedUnit || units' @click='openUnitSelect')
                                select-field.input-box-field__unit-select(v-if='units' v-model='selectedUnit' :options='unitOptions' ref='unitSelect')
                                span {{ selectedUnit || '&nbsp;' }}
                            char-limit-warning(v-if='ready && limit' :limit='limit' :text='modelNoUnit' :field='$refs.field')

                            slot(name='input-decorators' :hover='fieldHover')

                        div.input-box-field__wrap(@mouseover='fieldHover = true' @mouseleave='fieldHover = false')
                            slot(name='input-decorators-alt' :hover='fieldHover')

                        inline-error-control(:errors='errors' :relative='!absoluteError')
                    
                    div.input-box-field__container-tooltip(v-if='tooltip')
                        tooltip-control(:tooltip='tooltip')

            div.input-field__description(v-if='description') {{ description }}
</template>

<script>
export default {
    name: 'input-box-field',
    props: {
        value: [String, Number],
        unit: String,
        units: Array,
        label: String,
        hideLabel: Boolean,
        placeholder: String,
        description: String,
        disabled: Boolean,
        readonly: Boolean,
        absoluteError: {
            type: Boolean,
            default() {
                return false
            },
        },
        limit: {
            default: 0,
            type: Number,
        },
        tooltip: {
            type: String,
        },
        mode: {
            type: String,
        },
        type: {
            type: String,
            default() { return 'text' },
        },
    },
    data() {
        return {
            modelValue: null,

            ready: false,

            fieldHover: false,

            selectedUnit: '',
        }
    },
    computed:{
        model: {
            get() {
                return this.modelValue
            },
            set(val) {
                this.modelValue = val
                this.$emit('input', val)
            },
        },
        modelStr() {
            return this.model ? this.model.toString() : ''
        },
        modelNoUnit: {
            get() {
                return this.selectedUnit && this.modelStr.endsWith(this.selectedUnit) ?
                        this.modelStr.substring(0, this.modelStr.length - this.selectedUnit.length) :
                        this.modelStr
            },
            set(val) {
                this.model = `${val}${this.selectedUnit || ''}`
            },
        },

        unitOptions() {
            if (Array.isArray(this.units)) {
                return this.units.map(u => ({
                    value: u,
                    name: u,
                }))
            }
        },

        typeNumber() {
            return this.type == 'number'
        },
        typeInteger() {
            return this.type == 'integer'
        },

        theClass() {
            return {
                'input-box-field--mode-compact': this.mode == 'compact',
                'input-box-field--unit': !!this.selectedUnit || this.units,
            }
        },
        fieldClass() {
            return {
                'char-limit-warning-field': this.limit > 0,
            }
        },

        fieldEl() {
            return this.$refs.field
        },
    },
    watch: {
        value: {
            handler(val) {
                this.modelValue = val
            },
            immediate: true,
        },
        model() {
            this.detectSelectedUnit()
        },
        selectedUnit(val, oldVal) {
            if (oldVal) {
                this.model = `${this.model.substring(0, this.model.length - oldVal.length)}${val}`
            }
        },
    },
    methods: {
        change() {
            this.$emit('change', this.model)
        },
        focus() {
            this.$refs.field.focus()
        },
        onFocus() {
            this.$emit('focus')
        },
        onBlur() {
            this.$emit('blur')
        },

        checkType(e) {
            const keyCode = e.keyCode || e.which

            if (this.typeInteger) {
                if (keyCode < 48 || keyCode > 57) {
                    e.preventDefault()
                }
                return
            }

            if (this.typeNumber) {
                if (keyCode >= 48 && keyCode <= 57) {
                    return
                }
                if (keyCode == 46) {
                    const val = e.target.value
                    if (!val.includes('.') && val.length > 0) {
                        return
                    }
                }
                e.preventDefault()
                return
            }
        },

        detectSelectedUnit() {
            if (this.unit) {
                this.selectedUnit = this.unit
            }
            else if (this.units && this.model) {
                this.selectedUnit = this.units.find(u => this.modelStr.endsWith(u))
            }
        },

        openUnitSelect() {
            if (this.units) {
                this.$refs.unitSelect.openList()
            }
        },
    },
    mounted() {
        this.ready = true
    },
    created() {
        this.detectSelectedUnit()
    },
}
</script>